export default "__VITE_ASSET__CP3MWA57__"